import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { CallbackComponent } from "redux-oidc";
import userManager from "../../services/userManager";
import { getRedirectUri, clearRedirectUri } from "../../routes/redirectStorage";
import { store } from '../../redux/store';
import { loadUser } from "redux-oidc";
import * as notifications from "../../redux/actions/notificationsActions";
import * as sessionActions from "../../redux/actions/sessionActions";
import {
    isRecoverableSigninError,
    purgeOidcState,
    hasRetriedSignin,
    markSigninRetried,
    clearSigninRetry
} from "../../utils/oidcStorage";
import { clearTenantArrivals } from "../../utils/tenantAccessGuard";

export class CallbackPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redirectUri: null
        };
    }

    componentDidMount() {
        this.setState({
            redirectUri: getRedirectUri()
        });
    }

    handleSuccess = (user) => {
        loadUser(store, userManager);
        clearRedirectUri();
        clearSigninRetry();
        // Possibly another account than the one that got caught in a reload loop.
        clearTenantArrivals();
        this.props.actions.sessionActivated();
        this.props.history.replace(this.state.redirectUri);
    }

    handleError = (error) => {
        // A second callback for a state we already consumed - back button, reload, or
        // the page being restored. The session itself is fine, so carry on.
        if (!!this.props.oidc && !!this.props.oidc.user && !this.props.oidc.user.expired) {
            this.props.history.replace(this.state.redirectUri);
            return;
        }

        // The response carries a state this browser never stored, so there is nothing
        // to complete. Drop whatever is left over and start one clean login; the retry
        // marker keeps a second identical failure from turning into a redirect loop.
        if (isRecoverableSigninError(error) && !hasRetriedSignin()) {
            markSigninRetried();
            purgeOidcState();
            userManager.signinRedirect().catch(() => this.failToErrorPage());
            return;
        }

        this.failToErrorPage();
    }

    failToErrorPage = () => {
        // A translation key, not the raw library message: the English original ends up
        // machine translated into nonsense by the browser and means nothing to a user.
        this.props.actions.notificationError("LoginFailed");
        this.props.history.replace("/error");
    }

    render() {
        return (
            <CallbackComponent
                userManager={userManager}
                successCallback={this.handleSuccess}
                errorCallback={this.handleError}
            >
                <div />
            </CallbackComponent>
        );
    }
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            notificationError: bindActionCreators(notifications.notificationError, dispatch),
            sessionActivated: bindActionCreators(sessionActions.sessionActivated, dispatch),
        }
    };
}

export const Callback = connect(mapStateToProps, mapDispatchToProps)(CallbackPage);
